export default function countUploading(progressEvent) {
  // eslint-disable-next-line radix
  return parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
}
